import { z } from "zod";
import { QcBizStaffSchema } from "./Staff";
import { QcBizSubMenuSchema } from "./guest/SubMenu";

// made this a sep import from the staff TS file in order to ease issues related to declratation order
// and circular references

export type QcBizStaffGroup = z.infer<typeof QcBizStaffGroupSchema>;
export const QcBizStaffGroupSchema = z.object({
  id: z.number().optional(),
  name: z.string().optional(),
  order_no: z.number().optional(),
  staffs: z.array(z.lazy(() => QcBizStaffSchema)).optional(),
  sub_menus: z.array(z.lazy(() => QcBizSubMenuSchema)).optional(),
  tenant_id: z.number().optional(),
});

export type QcBizBelong = z.infer<typeof QcBizBelongSchema>;
export const QcBizBelongSchema = z.object({
  id: z.number().optional(),
  staff_group: z.lazy(() => QcBizStaffGroupSchema).optional(),
  staff_group_id: z.number().optional(),
  staff_id_account: z.number().optional(),
});

export type Groups = z.infer<typeof GroupsSchema>;
export const GroupsSchema = z.object({
  busy_total: z.number().optional(),
  call_state: z.string().optional(),
  is_login: z.boolean().optional(),
  name: z.string().optional(),
  online_total: z.number().optional(),
  order_no: z.number(),
  staff_group_id: z.number(),
  state: z.string().optional(),
});
